import { PageHeader } from "@/components/admin/common";
import AvailabilityCalendar from "@/components/admin/AvailabilityCalendar";

export default function CalendarPage() {
  return (
    <div className="max-w-6xl" data-testid="calendar-page">
      <PageHeader title="Booking calendar" subtitle="Tap a date to see who's booked. Switch to Year for the whole season." />
      <AvailabilityCalendar defaultView="year" />
    </div>
  );
}
